import { jss } from '../tools/jss';
import { layout } from '../tools/layout';
import { mui } from '../tools/mui';

const Button = jss.withStyles((theme) => ({
  root: {
    height: layout.pxToRem(32),
    lineHeight: 1,
  },
  outlined: {
    backgroundColor: theme.palette.white,
  },
  outlinedPrimary: {
    borderColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.white,
    },
  },
}))(mui.Button);

export default Button;
